import React, {useState, useEffect} from 'react';
import {api} from '../../../../../utils/api-client';
import CopyForm from './copy-form';

type GenerateCodeFormProps = {
  onClose: () => void;
  companyId?: string;
  isOpen?: boolean;
};
function GenerateCodeForm({
  companyId,
  onClose,
  isOpen = false,
}: GenerateCodeFormProps) {
  const [loginLink, setLoginLink] = useState('');
  const [status, setStatus] = useState('idle');
  useEffect(() => {
    if (!isOpen || !companyId) {
      setStatus('idle');
      setLoginLink('');
      return;
    }

    const fetchCode = async () => {
      setStatus('loading');
      const resp = await api.get(`backoffice/company/${companyId}/code`);
      setLoginLink(
        `${window.location.origin}/gakki/password-enable?code=${resp.data}`,
      );
      setStatus('success');
    };
    fetchCode();
  }, [isOpen, companyId]);

  return (
    <CopyForm
      value={<span data-test-id={'login-link'}>{loginLink}</span>}
      title={'登入連結'}
      onClose={onClose}
      isOpen={isOpen}
      isLoading={status === 'loading'}
    />
  );
}

export default GenerateCodeForm;
